import { Flex } from '@/components/base';
import Heading from '@/components/Typography/Heading';

const CustomerUploadPage = () => {
  return (
    <Flex style={{ padding: '16px 24px' }}>
      <Heading type="h3">Contact upload</Heading>
    </Flex>
  );
};

export default CustomerUploadPage;
